import { defineMessage } from 'react-intl';

export const firstMissionDescription = defineMessage({
  id: 'football.promoOnboarding.missionDescription',
  defaultMessage: 'Select your first 4 players',
});
